function ImageLoaderProcess() {
  this.images = []
}

ImageLoaderProcess.prototype.add = function(file) {
  if (file.constructor.name === 'Array') {
    file.forEach(x => this.images.push(x))
  }
  else {
    this.images.push(file)
  }
}

ImageLoaderProcess.prototype.preLoadImageUrls = function(dispatch) {
  if (this.images.length === 0) {
    return Promise.resolve(null)
  }
  return dispatch('filestore/getFileURLBulk', { files: this.images })
    // .then(images => Object.values(images).forEach(_file => console.log(`${_file} loaded.`)))
    .then(_ => null)
}

export default ImageLoaderProcess
